/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FaChevronDown } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import Select from 'react-select';

const cities = {
    ABAALWOROOD: 'ابا الورود',
    ABHA: 'ابها',
    ABHAMANHAL: 'ابها المنهل',
    ABQAIQ: 'بقيق',
    ABUAJRAM: 'ابو عجرم',
    ABUAREISH: 'ابو عريش',
    ADDAHINAH: 'الداهنة',
    ADDUBAIYAH: 'الضبيعة',
    ADDAYER: 'الداير',
    ADHAM: 'أضم',
    AFIF: 'عفيف',
    AFLAJ: 'افلج',
    AHADMASARHA: 'احد مسارحه',
    AHADRUFAIDAH: 'احد رفيده',
    AINDAR: 'عين دار',
    ALADARI: 'الادري',
    ALAIS: 'العيص',
    ALAJFAR: 'الاجفار',
    ALAMMARAH: 'العامرية',
    ALARDAH: 'العارضة',
    ALARJA: 'العرجة',
    ALASYAH: 'العاصية',
    ALBADA: 'البدع',
    ALBASHAYER: 'البشاير',
    ALBATRA: 'البترا',
    ALBIJADYAH: 'البجادية ',
    ALDALEMYA: 'الدليميه',
    ALFUWAILEQ: 'الفويلق',
    ALHAITH: 'الحائط ',
    ALHASSA: 'الاحساء',
    ALHAYATHEM: 'الهياثم',
    ALHUFAYYIRAH: 'الحفيرة',
    ALHULAYFAHASSUFLA: ' الحليفة السفلى ',
    ALIDABI: 'العيدابي',
    ALKHISHAYBI: 'الخشيبي',
    ALKHITAH: 'الخطة ',
    ALLAQAYIT: 'اللقايط',
    ALMADA: 'المدا',
    ALMADAYA: 'الماضايا',
    ALMAHANI: 'المحاني',
    ALMAHD: 'المهد',
    ALMIDRIJ: 'المدراج',
    ALMOYA: 'الموية',
    ALQARIN: 'قنا',
    ALUWAYQILAH: 'العويقيلية',
    ALWASAYTA: 'الوسيطاء',
    ALGHAT: 'الغاط',
    ALHADA: 'الهدى',
    ALJSH: 'الجش',
    ALNABHANYA: 'النبهانية',
    ALRASS: 'الرس',
    AMAQ: 'عمق',
    ANNABKABUQASR: 'النبك ابو قصر',
    ANNAFIAH: 'النافية',
    ANNUQRAH: 'النقرة',
    ANAK: 'عنك',
    AQIQ: 'عقيق',
    AQOOL: 'عقول',
    ARRADIFAH: 'الرديفه',
    ARRAFIAH: 'الرفيعة',
    ARAR: 'عرعر',
    ARTAWIAH: 'الارطاوية',
    ASSULAIMANIYAH: 'عشيرة',
    ASSULUBIAYH: 'الصلبيّة',
    ASFAN: 'عسفان',
    ASHSHAARA: 'الشرائع',
    ASHSHAMLI: 'الشملي',
    ASHSHANANAH: 'الشنانه',
    ASHSHIMASIYAH: 'الشماسية',
    ASHSHUQAIQ: 'الشقيق',
    ASHEIRAH: 'عشيرة',
    ATTUWAYR: 'الطوير',
    ATAWLEH: 'اطاولة',
    ATHTHYBIYAH: 'الذيبيه - حفر الباطن',
    AWAMIAH: 'عواميه',
    AYNFUHAYD: 'عين فهيد',
    BADAYA: 'البدائع',
    BADER: 'بدر',
    BADRALJANOUB: 'بدر الجنوب',
    BAHA: 'الباحة',
    BAHARA: 'بحرا',
    BAHRABUSUKAYNAH: 'بحر ابو سكينة',
    BAHRATALMOUJOUD: 'بحرة الموجود',
    BALAHMAR: 'بلحمر',
    BALASMAR: 'بللسمر',
    BALQARN: 'بلقرن',
    BAQAASHSHARQIYAH: 'باقة الشرقيه',
    BAQAA: 'بقعة',
    BAQIQ: 'بقيق',
    BAREQ: 'بارق',
    BATHA: 'بطحه',
    BILJURASHI: 'بلجرشي',
    BIRK: 'برك',
    BISH: 'بيش',
    BISHA: 'بيشة',
    BUKEIRIAH: 'البكيرية',
    BURAIDAH: 'بريدة',
    DAELIM: 'الدلم',
    DAMAD: 'ضمد',
    DAMMAM: 'الدمام',
    DARB: 'درب',
    DARIYAH: 'ضرية',
    DAWADMI: 'الدوادمي',
    DERAAB: 'ديراب',
    DHABYAH: 'ظبيه',
    DHAHBAN: 'دهبان',
    DHAHRAN: 'الظهران',
    DHAHRANALJANOOB: 'ظهران الجنوب',
    DHURMA: 'الدرمه',
    DOMATALJANDAL: 'دومة الجندل',
    DUBA: 'ضبا',
    DUHKNAH: 'دخنة ',
    DULAYRASHID: 'ضليع رشيد',
    FARASAN: 'فرسان',
    GHAZALAH: 'غزالية',
    GHTAI: 'غطي ',
    GILWA: 'قلوه',
    GIZAN: 'جازان',
    HADEETHAH: 'الحديثه',
    HAFERALBATIN: 'حفر الباطن',
    HAIL: 'حائل',
    HAJRAH: 'حجره',
    HALATAMMAR: 'حالة عمار',
    HALI: 'حلي',
    HAQIL: 'حقل',
    HARAD: 'حرض',
    HARAJAH: 'حرجه',
    HAREEQ: 'الحريق',
    HAWEA_TAIF: 'حوية/طائف',
    HAWEYAH_DHA: 'هويه/الدمام',
    HAWTATBANITAMIM: 'حوطة بني تميم',
    HAZMALJALAMID: 'حزم الجلاميد',
    HEDEB: 'هديب',
    HINAKEYA: 'الحناكية',
    HOFUF: 'الهفوف',
    HORAIMAL: 'حريملاء',
    HOTATSUDAIR: 'حوطة سدير',
    HUBUNA: 'حبونا',
    HURAYMALA: 'حريملاء',
    HUROOB: 'هروب',
    JAARANEH: 'الجعرانه',
    JAFAR: 'جفر',
    JALAJEL: 'جلاجل',
    JEDDAH: 'جدة',
    JOUF: 'الجوف',
    JUBAIL: 'الجبيل',
    JUMUM: 'الجموم',
    KAHLAH: 'كحله',
    KARA: 'كارا',
    KARAA: 'كرع',
    KARBOOS: 'كربوس',
    KHAFJI: 'الخفجي',
    KHAIBAR: 'خيبر',
    KHAIRAN: 'تمرة ',
    KHAMASEEN: 'خماسين',
    KHAMISMUSHAIT: 'خميس مشيط',
    KHARJ: 'الخرج',
    KHASAWYAH: 'خصاويه',
    KHOBAR: 'الخبر',
    KHODARIA: 'خضريه',
    KHULAIS: 'خليص',
    KHURMA: 'الخرمة',
    KINGABDULLAHECONOMICCITY_KAEC: 'مدينة الملك عبدالله الاقتصادية',
    KINGKHALIDMILITARYCITY: 'مدينة الملك خالد العسكرية ',
    KUBADAH: 'كبضه',
    LAITH: 'ليث',
    LAYLA: 'ليلى',
    MADINAH: 'المدينة المنورة',
    MAHADALDAHAB: 'مهد الدهب',
    MAJARDA: 'المجاردة',
    MAJMA: 'المجمعة',
    MAKKAH: 'مكة المكرمة',
    MANDAK: 'مندق',
    MASTURA: 'مستوره',
    MAWQAQ: 'موقق',
    MIDINHAB: 'المذنب',
    MIKHWA: 'مخواه',
    MOHAYELASEER: 'محايل',
    MOQAQ: 'مقيق',
    MRAT: 'مرات',
    MUBARAZ: 'المبرز',
    MUBAYID: 'مبايض',
    MULAIJA: 'الموليجه',
    MULAYH: 'مليح ',
    MUNIFATALQAID: 'منيفت القيد',
    MUTHALEIF: 'المظيلف',
    MUZAHMIAH: 'المزاحمية',
    MUZNEB: 'مذنب',
    NABIYA: 'نبيه',
    NAJRAN: 'نجران',
    NAMAS: 'نماص',
    NEWMUWAYH: 'مويه الجديدة',
    NIMRA: 'نمره',
    NISAB: 'نصاب',
    NOWEIRIEH: 'النعيرية',
    OJAM: 'عجم',
    ONAIZA: 'عنيزة',
    OTHMANYAH: 'العثمانيه',
    OULA: 'العلا',
    OYAYNAH: 'العيينة',
    OYOONALJAWA: 'عيون الجوا',
    QAHMAH: 'القحمة',
    QANA: 'قنا',
    QARAH: 'قاره',
    QARIYAALOLAYA: 'قرية العليا',
    QASAB: 'قصب',
    QASSIM: 'القصيم',
    QATIF: 'القطيف',
    QAYSOOMAH: 'قيصومه',
    QBAH: 'قبه',
    QOUZ: 'القوز',
    QUFAR: 'قفار',
    QUNFUDAH: 'القنفذة',
    QURAYAT: 'القريات',
    QUSAYBA: 'قصيباء',
    QUWEIIEH: 'القويعية',
    RABIGH: 'رابغ',
    RAFHA: 'رفحاء',
    RAHIMA: 'رحمه',
    RANIA: 'رانيا',
    RASALKHEIR: 'راس الخير',
    RASBARIDI: 'طارق أملج',
    RASTANURA: 'راس تنورة',
    RAWDATHABBAS: 'روضه هباس',
    REJALALMAA: 'رجال المع',
    REMAH: 'رماح',
    RIYADH: 'الرياض',
    RIYADHALKHABRA: 'رياض الخبراء',
    ROWDATSODAIR: 'روضه سودير',
    RVAYAALJAMSH: 'رافا الجماش',
    RWAYDAH: 'الرويضه',
    SABTELALAYA: 'سبت العلايا',
    SABYA: 'صبيا',
    SADALMALIK: 'سعد أل مالك',
    SADYAN: 'سديان',
    SAFANYAH: 'سفنيه',
    SAFWA: 'صفوى',
    SAHNA: 'سحنه',
    SAJIR: 'ساجر',
    SAKAKA: 'سكاكا',
    SALBOOKH: 'سلبوكه',
    SALWA: 'سلوى',
    SAMAKH: 'سمكه',
    SAMTAH: 'صامطة',
    SAQF: 'سقف',
    SARAR: 'صراره',
    SARATOBEIDA: 'سراة عبيده',
    SATORP_JUBAILINDL2: 'الجبيل الصناعية 2',
    SEIHAT: 'سيهات',
    SHAQRA: 'شقراء',
    SHARI: 'شري ',
    SHAROURAH: 'شرورة',
    SHEFAA: 'شفا',
    SHINANH: 'شينانة',
    SHOAIBA: 'الشعيبه',
    SHRAIEE: 'الشرايع',
    SHUMEISI: 'الشميسي',
    SIIR: 'سر',
    SIMIRA: 'سيميرا',
    SUBHEKA: 'صبيخة',
    SULAIYL: 'السليل',
    SUWAYR: 'صوير',
    TABLAH: 'طبلة',
    TABRJAL: 'تبرجل',
    TABUK: 'تبوك',
    TAIBA: 'طيبه',
    TAIF: 'الطائف',
    TANDA: 'تندحة',
    TANJEEB: 'تنجيب',
    TANUMA: 'تنوما',
    TANUMAH: 'تنيوما',
    TARUT: 'تاروت',
    TATLEETH: 'تثليث',
    TAYMA: 'تيماء',
    TEBRAK: 'تبراك',
    THABYA: 'ذبية',
    THADEK: 'ثادق',
    THARMADA: 'ثرمادا',
    THEBEA: 'الذيبية - القصيم',
    THUMAIR: 'تمير',
    THUQBA: 'ثقبا',
    TOWAL: 'ثول',
    TURAIB: 'طريب',
    TURAIF: 'طريف',
    TURBA: 'تربه',
    TUWAIM: 'تويم',
    UDHALIYAH: 'الدهليه',
    UMALJAMAJIM: 'ام الجماجم',
    UMLUJ: 'املج',
    UQLATALSUQUR: 'عقلة الصقور',
    USHAYQIR: 'اشيقر',
    UYUN: 'العيون',
    WADEIEN: 'الواديين',
    WADIBINHASBAL: 'وادي بن هشبل',
    WADIELDWASER: 'وادي الدواسر ',
    WADIFARAAH: 'وادي فرح',
    WADIFATMAH: 'وادي فاطمه',
    WAJEH_ALWAJH: 'الوجه',
    WALYALAHD: 'ولي العهد',
    YADAMAH: 'يدمة',
    YANBU: 'ينبع',
    YANBUALBAHER: 'ينبع البحر',
    YANBUNAKHIL: 'ينبع النخيل',
    YUTHMA: 'يوتما',
    ZALLUM: 'زلوم',
    ZULFI: 'الزلفي'
};



const bankNameMapping = {
    80: "مصرف الراجحي",
    20: "بنك الرياض",
    "05": "مصرف الإنماء",
    10: "البنك الأهلي السعودي",
    55: "البنك السعودي الفرنسي",
    45: "البنك السعودي البريطاني",
    15: "بنك البلاد",
    65: "البنك السعودي للاستثمار",
    30: "البنك العربي",
    60: "بنك الجزيرة",
    78: "STC"
};
const bank_codes = {
    '80': 'RJHI',
    '20': 'RIBL',
    '05': 'INMA',
    '10': 'NCBK',
    '55': 'BSFR',
    '45': 'SABB',
    '15': 'ALBI',
    '65': 'SIBC',
    '30': 'ARNB',
    '60': 'BJAZ',
    '78': 'STC'
}


const customStyles = {
    container: (provided) => ({
        ...provided,
        direction: 'rtl', // Ensure text direction is RTL
    }),
    control: (provided) => ({
        ...provided,
        textAlign: 'right', // Align text to the right
        padding: '0', // Remove default padding
        border: '1px solid #ccc', // Border style
        borderRadius: '0.375rem', // Border radius for rounded corners
        boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)', // Optional: shadow for better visibility
    }),
    placeholder: (provided) => ({
        ...provided,
        textAlign: 'right', // Align placeholder text to the right
        direction: 'rtl', // Right-to-left text direction
    }),
    singleValue: (provided) => ({
        ...provided,
        textAlign: 'right', // Align selected value text to the right
        direction: 'rtl', // Right-to-left text direction
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: '0', // Remove default padding
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none', // Hide the indicator separator if needed
    }),
};

const apiUrl = process.env.REACT_APP_API_URL;
const PrefilledCityFlag = process.env.REACT_APP_REMOVE_PREFILLED_CITIES;
const PrefilledAddressFlag = process.env.REACT_APP_REMOVE_PREFILLED_ADDRESS;


export const RefundForm = () => {
    const location = useLocation();
    const {
        totalAmount,
        totalAmountWithTax,
        notRefundable,
        refundFee,
    } = location.state || {};
    const [citiesOptions, setCitiesOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showOtherFields, setShowOtherFields] = useState(false);
    const { t } = useTranslation();
    const { totalPrice, orderData, orderItems, setTotalPrice, setTotalQuantity, setOrderData, setOrderItems } = useAuth();
    const navigate = useNavigate();
    const paymentMethodIncludesTabbyOrTamara = orderData?.payment_method?.toLowerCase().includes('madfu_installment') || orderData?.payment_method?.toLowerCase().includes('tabby') || orderData?.payment_method?.toLowerCase().includes('tamara');
    const getBankName = (iban) => {
        if (!iban.startsWith("SA") || iban.length !== 24) {
            return t("unknown-bank");
        }
        const bankIdentifier = iban.substring(4, 6);
        return t(bankNameMapping[bankIdentifier] || "unknown-bank");
    };

    const ibanValidationSchema = Yup.string()
        .transform(value => value?.replace(/[-\s]/g, '')) // Removes dashes & spaces
        .matches(/^SA[0-9A-Z]{22}$/, t('invalid-iban-format')) // Ensures correct format
        .required(t('iban-required'))
        .test("remove-spaces", t('iban-no-spaces'), (value) => !/\s/.test(value))
        .transform(value => value.replace(/\s+/g, '')); // Removes spaces        


    const validationSchema = Yup.object({
        firstName: Yup.string().required(t("first-name-required")).test('not-a-url', t('cannotBeUrl'), value => {
            const trimmedValue = value?.trim();
            const urlRegex = /^(https?:\/\/(?:www\.)?[^\s$.?#].[^\s]*$)/;
            const simpleUrlRegex = /^(?!\s*$)(\S+\.\S+|\S+\.\S+\.\S+)(?!\S)/;
            const invalidContentRegex = /(\S+\.\S+.*[^\s])$/;
            return !urlRegex.test(trimmedValue) && !simpleUrlRegex.test(trimmedValue) && !invalidContentRegex.test(trimmedValue);
        }),
        secondName: Yup.string().required(t("second-name-required")).test('not-a-url', t('cannotBeUrl'), value => {
            const trimmedValue = value?.trim();
            const urlRegex = /^(https?:\/\/(?:www\.)?[^\s$.?#].[^\s]*$)/;
            const simpleUrlRegex = /^(?!\s*$)(\S+\.\S+|\S+\.\S+\.\S+)(?!\S)/;
            const invalidContentRegex = /(\S+\.\S+.*[^\s])$/;
            return !urlRegex.test(trimmedValue) && !simpleUrlRegex.test(trimmedValue) && !invalidContentRegex.test(trimmedValue);
        }),
        iban: !paymentMethodIncludesTabbyOrTamara ? ibanValidationSchema : Yup.string(),
        email: Yup.string().email(t("invalid-email-format")).required(t("email-required")),
        reason: Yup.string().required(t("reason-required")).test('not-a-url', t('cannotBeUrl'), value => {
            const trimmedValue = value?.trim();
            const urlRegex = /^(https?:\/\/(?:www\.)?[^\s$.?#].[^\s]*$)/;
            const simpleUrlRegex = /^(?!\s*$)(\S+\.\S+|\S+\.\S+\.\S+)(?!\S)/;
            const invalidContentRegex = /(\S+\.\S+.*[^\s])$/;
            return !urlRegex.test(trimmedValue) && !simpleUrlRegex.test(trimmedValue) && !invalidContentRegex.test(trimmedValue);
        }),
        city: Yup.string()
            .required(t("city-required"))
            .test("valid-city", t("invalid-city"), (value) => {
                if (!value) return false;
                const exists =
                    Object.keys(cities).includes(value) ||
                    Object.values(cities).includes(value);
                return exists;
            }),
            address: Yup.string()
            .trim()
            .required(t("address-required"))
            .max(500, t("address-max-500"))
            .test('not-a-url', t('cannotBeUrl'), value => {
                const trimmedValue = value?.trim();
                const urlRegex = /^(https?:\/\/(?:www\.)?[^\s$.?#].[^\s]*$)/;
                const simpleUrlRegex = /^(?!\s*$)(\S+\.\S+|\S+\.\S+\.\S+)(?!\S)/;
                const invalidContentRegex = /(\S+\.\S+.*[^\s])$/;
                return !urlRegex.test(trimmedValue) &&
                       !simpleUrlRegex.test(trimmedValue) &&
                       !invalidContentRegex.test(trimmedValue);
            }),
        shortAddress: process.env.REACT_APP_FEATURE_SHORT_ADDRESS_ENABLED !== 'true' ? Yup.string() : Yup.string()
        .required(t("validation.short_address_required"))
        .matches(
          /^[A-Za-z]{4}[0-9]{4}$/,
          t("validation.short_address_format")
        )
        .test(
          "valid-format",
          t("validation.short_address_invalid"),
          (value) => {
            if (!value) return false;
            const letters = value.substring(0, 4);
            const digits = value.substring(4, 8);
            return /^[A-Za-z]{4}$/.test(letters) && /^\d{4}$/.test(digits);
          }
        ),
        others: showOtherFields ? Yup.string().required(t("reason-required")).max(500, t("reason-max-500")).test('not-a-url', t('cannotBeUrl'), value => {
            const trimmedValue = value?.trim();
            const urlRegex = /^(https?:\/\/(?:www\.)?[^\s$.?#].[^\s]*$)/;
            const simpleUrlRegex = /^(?!\s*$)(\S+\.\S+|\S+\.\S+\.\S+)(?!\S)/;
            const invalidContentRegex = /(\S+\.\S+.*[^\s])$/;
            return !urlRegex.test(trimmedValue) && !simpleUrlRegex.test(trimmedValue) && !invalidContentRegex.test(trimmedValue);
        })
            : Yup.string()
    });

    useEffect(() => {
        const cachedOrderData = JSON.parse(localStorage.getItem('orderData'));
        const cachedOrderItems = JSON.parse(localStorage.getItem('orderItems'));
        const cachedTotalPrice = localStorage.getItem('totalPrice');
        const cachedTotalQuantity = localStorage.getItem('totalQuantity');

        if (cachedOrderData && cachedOrderItems) {
            setOrderData(cachedOrderData);
            setOrderItems(cachedOrderItems);
            setTotalPrice(cachedTotalPrice);
            setTotalQuantity(cachedTotalQuantity);

            formik.setValues({
                firstName: cachedOrderData?.Customer?.first_name || "",
                secondName: cachedOrderData?.Customer?.last_name || "",
                iban: "",
                email: cachedOrderData?.Customer?.email || "",
                reason: "",
                shortAddress: "",
                city: PrefilledCityFlag ? "" : getCityKey(cachedOrderData?.Customer?.city || ""),
                address: PrefilledAddressFlag ? "" : cachedOrderData?.Customer?.address || ""
            });

            setCitiesOptions(Object.keys(cities).map(key => ({
                value: key,
                label: cities[key]
            })));
        }
    }, []);


    const handleReasonChange = (event) => {
        const selectedReason = event.target.value;
        formik.setFieldValue('reason', selectedReason);
        setShowOtherFields(selectedReason === 'other'); // Show textarea if 'other' is selected
    };

    const handleLoading = (value) => setLoading(value)

    const getCityKey = (arabicCityName) => {
        return Object.keys(cities).find(key => cities[key] === arabicCityName);
    };

    const getBankKey = (bankValue) => {
        const key = Object.keys(bankNameMapping).find(key => bankNameMapping[key] === bankValue)
        return bank_codes[`${key}`]
    }

    const handleShortAddressChange = (e) => {
        let value = e.target.value.toUpperCase().replace(/[^0-9A-Z]/g, '');
        if (value.length > 8) value = value.substring(0, 8);
        formik.setFieldValue('shortAddress', value);
    };

    const formik = useFormik({
        initialValues: {
            firstName: orderData?.Customer?.first_name || "",
            secondName: orderData?.Customer?.last_name || "",
            iban: "",
            email: orderData?.Customer?.email || "",
            reason: "",
            shortAddress: "",
            city: PrefilledCityFlag ? "" : citiesOptions.find(option => option.value === orderData?.Customer?.city) || "",
            address: PrefilledAddressFlag ? "" : orderData?.Customer?.address || "",
            others: "", // Field for the "other" reason
        },
        validationSchema,
        onSubmit: async (values) => {
            const bankName = getBankName(values.iban);

            if (!paymentMethodIncludesTabbyOrTamara && bankName === t("unknown-bank")) {
                toast.error(t("invalid-bank"));
                return;
            }
            const returnItems = orderItems
                .filter(item => item.refund_quantity > 0)
                .map(item => ({
                    product_id: item.Product.id,
                    quantity: item.refund_quantity
                }));
            const payload = {
                payment_method: orderData?.payment_method,
                items: returnItems,
                refund_amount: (parseFloat((totalPrice - 0.01) * 100) / 100) - process.env.REACT_APP_REFUND_FEE > 0 ? parseFloat(((parseFloat((totalPrice - 0.01) * 100) / 100) - process.env.REACT_APP_REFUND_FEE).toFixed(2)) : 0,
                city: values.city,
                reason: values.reason === "other" ? values.others : values.reason,
                first_name: values.firstName,
                last_name: values.secondName,
                email: values.email,
                bank_code: '',
                address: values.address,
                total_with_tax: totalAmountWithTax,
                total_refundable_amount: totalAmount,
                total_non_refundable_amount: notRefundable,
                return_fees: refundFee,
            }

            if (process.env.REACT_APP_FEATURE_SHORT_ADDRESS_ENABLED === 'true' && values.shortAddress) {
                payload.short_address = values.shortAddress;
            }

            if (values.iban) {
                payload.iban = values.iban
                payload.bank_code = getBankKey(getBankName(formik.values.iban))
            }
            const token = localStorage.getItem('token');
            try {
                handleLoading(true)
                const response = await axios.post(
                    `${apiUrl}/refund-requests`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );
                handleLoading(false)
                if (response?.data?.uuid) {
                    toast.success("successfully submitted the refund request")
                    setTotalPrice(0);
                    setTotalQuantity(0);
                    localStorage.removeItem('orderData');
                    localStorage.removeItem('orderItems');
                    localStorage.removeItem('totalPrice');
                    localStorage.removeItem('totalQuantity');
                    setTimeout(() => {
                        navigate(`/bank-info/confirmation/${response?.data?.uuid}`);
                    }, 1000)
                }
            } catch ({ response }) {
                handleLoading(false)
                toast.error(response?.data?.message)
            }
        },
    });

    console.log('process.env.REACT_APP_FEATURE_SHORT_ADDRESS_ENABLED', process.env.REACT_APP_FEATURE_SHORT_ADDRESS_ENABLED)

    return (
        <div className="flex justify-center items-start mt-12 p-4">
            <ToastContainer />
            <div className="w-full md:w-1/2 lg:w-1/3 bg-white p-6 rounded-lg shadow-lg">
                <form onSubmit={formik.handleSubmit} className="space-y-5">
                    <div className="relative">
                        <label className="text-sm text-gray-600 mr-2 flex justify-end">
                            {t("first-name")}
                        </label>
                        <input
                            type="text"
                            name="firstName"
                            value={formik.values.firstName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="form-input w-full text-right placeholder-right border border-gray-300 p-2"
                            placeholder={t("first-name")}
                        />
                        {formik.touched.firstName && formik.errors.firstName ? (
                            <div className="text-red-500 text-sm mt-1 text-right">
                                {formik.errors.firstName}
                            </div>
                        ) : null}
                    </div>

                    <div className="relative">
                        <label className="text-sm text-gray-600 mr-2 flex justify-end">
                            {t("second-name")}
                        </label>
                        <input
                            type="text"
                            name="secondName"
                            value={formik.values.secondName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="form-input w-full text-right placeholder-right border border-gray-300 p-2"
                            placeholder={t("second-name")}
                        />
                        {formik.touched.secondName && formik.errors.secondName ? (
                            <div className="text-red-500 text-sm mt-1 text-right">
                                {formik.errors.secondName}
                            </div>
                        ) : null}
                    </div>

                    {!paymentMethodIncludesTabbyOrTamara && (
                        <div className="relative">
                            <label className="text-sm text-gray-600 mr-2 flex justify-end items-center gap-1">
                                {t("iban")}
                            </label>

                            <input
                                type="text"
                                name="iban"
                                value={formik.values.iban}
                                onChange={(e) => {
                                    const cleanedValue = e.target.value.replace(/[-\s]/g, '');
                                    formik.setFieldValue('iban', cleanedValue);
                                }}
                                onBlur={formik.handleBlur}
                                className="form-input w-full text-right placeholder-right border border-gray-300 p-2"
                                placeholder={t("iban")}
                            />

                            {formik.touched.iban && formik.errors.iban ? (
                                <div className="text-red-500 text-sm mt-1 text-right">
                                    {formik.errors.iban}
                                </div>
                            ) : null}
                            {orderData?.showIbanMessage && (
                                <div className="bg-yellow-100 text-yellow-800 text-xs rounded-lg px-3 py-2 right-0 bottom-full mb-1 shadow-md z-10 mt-2 border border-yellow-300">
                                    💡 {t("iban-message")}
                                </div>
                            )}


                            {formik.values.iban && !formik.errors.iban && (
                                <div className="text-gray-700 text-sm mt-2">
                                    {t("bank-name")}: {getBankName(formik.values.iban)}
                                </div>
                            )}
                        </div>
                    )}


                    <div className="relative">
                        <label className="text-sm text-gray-600 mr-2 flex justify-end">
                            {t("email")}
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="form-input w-full text-right placeholder-right border border-gray-300 p-2"
                            placeholder={t("email")}
                        />
                        {formik.touched.email && formik.errors.email ? (
                            <div className="text-red-500 text-sm mt-1 text-right">
                                {formik.errors.email}
                            </div>
                        ) : null}
                    </div>

                    <div className="flex flex-col items-end space-y-4">
                        <div className="relative w-full">
                            <label className="text-sm text-gray-600 mr-2 flex justify-end">
                                {t("select-reason")}
                            </label>
                            <select
                                name="reason"
                                value={formik.values.reason}
                                onChange={handleReasonChange}
                                onBlur={formik.handleBlur}
                                className="form-select w-full text-right appearance-none pr-2 py-2 border border-gray-400"
                            >
                                <option value="" disabled>
                                    {t("select-reason")}
                                </option>
                                <option value="perfume didn't suite me">
                                    {t("perfume-didn't-suite-me")}
                                </option>
                                <option value="I’d like to try another perfume">
                                    {t("I’d like to try another perfume")}
                                </option>
                                <option value="other">
                                    {t("other")}
                                </option>
                            </select>
                            <div className="absolute top-[65%] left-0 transform -translate-y-[40%] flex items-center px-2 pointer-events-none">
                                <FaChevronDown className="text-gray-400" />
                            </div>
                            {formik.touched.reason && formik.errors.reason ? (
                                <div className="text-red-500 text-sm mt-1 text-right">
                                    {formik.errors.reason}
                                </div>
                            ) : null}
                        </div>


                        {showOtherFields && (
                            <div className="relative w-full">
                                <label className="text-sm text-gray-600 mr-2 flex justify-end">
                                    {t("other")}
                                </label>
                                <input
                                    type="text"
                                    name="others"
                                    value={formik.values.others}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className="form-input w-full text-right placeholder-right border border-gray-400 p-2"
                                    placeholder={t("other")}
                                />
                                {formik.touched.others && formik.errors.others ? (
                                    <div className="text-red-500 text-sm mt-1 text-right">
                                        {formik.errors.others}
                                    </div>
                                ) : null}
                            </div>
                        )}

                        <div className="relative w-full">
                            <label className="text-sm text-gray-600 mr-2 flex justify-end">
                                {t("select-city")}
                            </label>
                            <Select
                                name="city"
                                options={citiesOptions}
                                value={citiesOptions.find(option => option.value === formik.values.city)}
                                onChange={(selectedOption) => {
                                    formik.setFieldValue('city', selectedOption.value);
                                }}
                                onBlur={formik.handleBlur}
                                placeholder={t("select-city")}
                                isClearable={false}
                                styles={customStyles}
                            />
                            {formik.touched.city && formik.errors.city ? (
                                <div className="text-red-500 text-sm mt-1 text-right">
                                    {formik.errors.city}
                                </div>
                            ) : null}
                        </div>

                        {/* Short Address - NEW FIELD */}
                        {process.env.REACT_APP_FEATURE_SHORT_ADDRESS_ENABLED === 'true' && (
                                                    <div className="relative">
                                                    <label className="text-sm text-gray-600 mr-2 flex justify-end">
                                                        {t("short_address")}
                                                    </label>
                        
                                                    <input
                                                        type="text"
                                                        name="shortAddress"
                                                        value={formik.values.shortAddress}
                                                        onChange={handleShortAddressChange}
                                                        onBlur={formik.handleBlur}
                                                        className="form-input w-full text-right placeholder-right border border-gray-400 p-2"
                                                        placeholder={t("short_address_placeholder")}
                                                        maxLength={8}
                                                    />
                        
                        <div className="bg-yellow-100 text-yellow-800 text-xs rounded-lg px-3 py-2 right-0 bottom-full mb-1 shadow-md z-10 mt-2 border border-yellow-300">
                                                            💡 {t("short_address_format")}
                                                        </div>
                                                    {formik.touched.shortAddress && formik.errors.shortAddress && (
                                                        <div className="text-red-500 text-sm mt-1 text-right">
                                                            {formik.errors.shortAddress}
                                                        </div>
                                                    )}
                                                </div>
                        )}


                        <div className="relative w-full">
                            <label className="text-sm text-gray-600 mr-2 flex justify-end">
                                {t("address")}
                            </label>
                            <textarea
                                name="address"
                                value={formik.values.address}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className="form-textarea w-full text-right placeholder-right border border-gray-400 p-2 h-20 resize-none"
                                placeholder={t("address")}
                            />
                            {formik.touched.address && formik.errors.address ? (
                                <div className="text-red-500 text-sm mt-1 text-right">
                                    {formik.errors.address}
                                </div>
                            ) : null}
                        </div>
                    </div>

                    <div className="text-left mt-6">
                        <button
                            disabled={loading}
                            type="submit"
                            className={`bg-black text-white py-2 px-4 rounded ${loading ? 'cursor-not-allowed opacity-50' : ''}`}
                        >
                            {t("complete-refund-request")}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

